/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2017 Dan "Ducky" Little
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/** Zoom To Action
 *
 *  When a user clicks on this it will zoom them to a given
 *  extent. The extent is expected to be in map coordinates.
 *
 */
function ZoomToAction(Application, options) {

    // The extent to which the action should zoom to.
    this.extent = options.extent ? options.extent : [-9417970.832865, 5224394.685108, -9366486.464156, 5278037.617856];

    // Called every time the action is started.
    this.run = function() {
        if(options.extent) {
            Application.zoomToExtent(options.extent);
        } else {
            alert('An extent was not defined for this action');
        }

    }

}

if(typeof(module) !== 'undefined') { module.exports = ZoomToAction; }
